<template>
  <div>
    <div class="grid grid-cols-3 w-full gap-x-3 gap-y-3 my-48">
      <div @click="show_create_premade_modal = true" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center text-blue-500 font-semibold uppercase text-lg">Create Premade</h1>
      </div>
      <div @click="goToSearchEditPremades" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center text-blue-500 font-semibold uppercase text-lg">Search and Edit Premades</h1>
      </div>
      <div @click="goToAdminEditCollections" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center text-blue-500 font-semibold uppercase text-lg">Edit Collections</h1>
      </div>
      <div @click="goToAdminUniverseSettings" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center text-blue-500 font-semibold uppercase text-lg">Edit Subjects / Grades / Skills</h1>
      </div>
      <div @click="goToSchoolManagement" class="bg-gray-100 rounded border border-solid py-2 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center text-blue-500 font-semibold uppercase text-lg">Manage Schools / Districts / Memberships / Teachers</h1>
      </div>
      <div @click="goToWelcomeModals" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center flex-grow justify-center text-blue-500 font-semibold uppercase text-lg align-middle">Welcome Modals</h1>
      </div>
      <div @click="goToGeniePrompts" class="bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200">
        <h1 class="text-center flex-grow justify-center text-blue-500 font-semibold uppercase text-lg align-middle">Genie Prompts</h1>
      </div>
    </div>
    <div class="flex justify-center">
      <button @click="signOut()" class="bg-blue-500 px-5 py-2 rounded text-whie font-medium text-white">Log Out</button>
    </div>
    <create-premade-modal
      v-if="show_create_premade_modal"
      @close="show_create_premade_modal = false"
    />
  </div>
  
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import premadeServices from 'services/premades/premadeServices';
  import createPremadeModal from 'components/modals/createPremadeModal';

  export default {
    data() {
      return {
        show_create_premade_modal: false,
      };
    },
    components: {
      createPremadeModal,
    },
    computed: {
      ...mapGetters([]),
    },
    methods: {
      goToCreatePremade() {
        premadeServices.createNewPremade().then(({ data }) => {
          this.$router.push({
            name: 'premade-form',
            params: {
              premadeID: data.id,
            },
          });
        });
      },
      signOut: function(){
        localStorage.removeItem('_prly_tk');
        sessionStorage.removeItem('exactRoute');
        Vue.router.go('login');
      },
      goToSchoolManagement() {
        this.$router.push({ name: 'admin-school-management' });
      },
      goToAdminUniverseSettings() {
        this.$router.push('admin-universe-settings');
      },
      goToSearchEditPremades() {
        this.$router.push('search-edit-premades');
      },
      goToAdminEditCollections() {
        this.$router.push('admin-manage-collections');
      },
      goToWelcomeModals() {
        this.$router.push('admin-welcome-modals');
      },
      goToGeniePrompts() {
        this.$router.push('admin-genie-prompts');
        return;
      }
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .dashboard {
    align-content: flex-start;
    margin-top: 10px;

    .items-center {
      margin-top: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// adminDashboard.vue?8dc62d4a